// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__3ZBJP","ContactCard":"Contact_ContactCard__1tsTd","ContactIcon":"Contact_ContactIcon__2blAn","ContactText":"Contact_ContactText__10ySn"};